export default {
    name: 'performance_code_alias',
    definition: {},
};
